import type { InputAttachment } from '@unriddle/validators';
import type { AnaraAttachment } from '@unriddle/validators/message/attachments';
import { match } from 'ts-pattern';

export const convertAttachmentToAnara = (
  attachment: InputAttachment,
): AnaraAttachment | null => {
  const result = match(attachment)
    .with({ type: 'image', data: { type: 'image_url' } }, (att) => ({
      type: 'input-attachment' as const,
      id: att.id,
      data: {
        type: 'image' as const,
        url: att.data.image_url.url,
        extension: att.extension || '',
        name: att.name || '',
      },
    }))
    .with({ type: 'text', data: { type: 'text' } }, (att) => ({
      type: 'input-attachment' as const,
      id: att.id,
      data: {
        type: 'text' as const,
        text: att.data.text,
        highlights: att.highlights,
        chatbotId: att.chatbotId || '',
        chatbotType: 'DOCUMENT',
      },
    }))
    .with({ type: 'mention', data: { type: 'mention' } }, (att) => ({
      type: 'input-attachment' as const,
      id: att.id,
      data: {
        type: 'mention' as const,
        chatbotId: att.chatbotId,
        chatbotName: att.data.chatbotName,
      },
    }))
    .otherwise(() => null);

  return result as AnaraAttachment | null;
};

export const convertAttachments = (
  attachments: (InputAttachment | AnaraAttachment)[],
): AnaraAttachment[] => {
  return attachments
    ?.map((attachment) => {
      if (attachment.type === 'input-attachment') {
        return attachment;
      }

      return convertAttachmentToAnara(attachment);
    })
    .filter((attachment) => attachment !== null);
};
